/**
 *  update by tannc 2018年12月24日20:33:50
 */

import { COMMON_DETAIL_API, COMMON_CLIENT_API, COMMON_STATISTICS_API } from '../../resource/index'
import axios from '../../config/axios.config'

export default {
  async fetchDetail () {
    return await axios.get(COMMON_DETAIL_API, {})
  },
  async resetClient () {
    return await axios.save(COMMON_CLIENT_API, {}, {})
  },
  async fetchSummary (searchDate) {
    return await axios.get(COMMON_STATISTICS_API, {searchDate: searchDate})
  }
}



// WEBPACK FOOTER //
// ./src/service/front/detailService.js